var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container},[_c('index-section-head',{scopedSlots:_vm._u([{key:"heading",fn:function(){return [_vm._v("\n      Фотогалерея\n    ")]},proxy:true}])}),_vm._v(" "),_c('event-photo',{attrs:{"items":_vm.photos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }